import { toast } from 'react-toastify';

import { RequestError } from 'types';

export const handleRequestError = (
  err: RequestError,
  backupErrorMessage: string,
  priorErrorMessage?: string
): void => {
  if (err && err?.response?.status >= 500) {
    console.error('[API] 5xx error', {
      message:
        err.response.data?.message ||
        err.response.data?.detail ||
        err.response.data?.title,
      status: err.response.status,
    });
  }

  const apiMessage = err.response?.data?.message || err.response?.data?.detail;

  const message = priorErrorMessage || apiMessage || backupErrorMessage;

  toast(message, {
    type: 'error',
  });
};
